<script>
  import { ignore } from "../../Common/tools";
  import { fadeIn, fadeOut } from "../../Common/fade";
  import QuizStepList from "./QuizStepList.svelte";
  import QuizSingleStep from "./QuizSingleStep.svelte";
  import QuizSingleStepSettings from "./QuizSingleStepSettings.svelte";
  import {External, M} from "../../external";
  import API from "../../main";

  export let widget,
    onChange = ignore,
    onRenderStep = ignore;

  let steps = widget.data.steps;

  let activeStep = null;

  let editStepFields = event => {
    activeStep = event.detail.step;
    onRenderStep(event.detail.index);
  };

  let editStepSettings = event => {
    let step = event.detail.step;

    External.Tools.showWindow({
      isModal: false,
      title: M.STEP_SETTINGS,
      icon: External.Popup.ICON_ADD,
      width: 500,
      forceAtRight: External.showBuilderPopupsOnFullHeight,
      action: {
        onShow: (popup, ui) => {
          popup.bindComponent(
            new QuizSingleStepSettings({
              target: popup.getContentArea(),
              props: {
                step: step,
                widget: widget,
                onChange: onChange
              }
            })
          );
        }
      }
    });
  };

  let onShowSteps = () => {
    activeStep = null;
    onRenderStep(0);
  };

  let onStepsChange = event => {
    steps = event.detail;
    onChange();
  };

  let onStepChange = () => {
    onChange();
  };

  let onChangeResults = () => {
    External.Tools.showWindow({
      isModal: false,
      title: M.MANAGE_QUIZ_RESULTS,
      icon: External.Popup.ICON_ADD,
      width: 625,
      forceAtRight: External.showBuilderPopupsOnFullHeight,
      action: {
        onShow: (popup, ui) => {
          popup.bindComponent(
            API.BuilderWidgets.Quiz.Results(
              popup.getContentArea(),
              widget,
              onChange
            )
          );
        }
      }
    });
  };
</script>

<div class="popup-widget-wrapper form-admin-style-2">
  <div class="admin-form-steps-wrapper">
    {#if activeStep === null}
      <div class="col20 f-left" in:fadeIn out:fadeOut>
        <QuizStepList
          {steps}
          on:editStepFields={editStepFields}
          on:editStepSettings={editStepSettings}
          on:change={onStepsChange} />
      </div>

      <div class="col20 mt-25 mb-5 f-left gray-section product-select-wrapper">
        <div class="col20 f-left ab-step center-vertically">
          <h4 class="roboto">{M.MANAGE_QUIZ_RESULTS}</h4>
          <a class="text-link blue-text" on:click={onChangeResults}>{M.SETTINGS}</a>
        </div>
      </div>

    {:else}
      <div class="col20 f-left" in:fadeIn out:fadeOut>
        <QuizSingleStep
          step={activeStep}
          {steps}
          on:back={onShowSteps}
          on:editStepSettings={editStepSettings}
          on:change={onStepChange} />
      </div>
    {/if}
  </div>
</div>
